import * as React from "react";

import { Button, Page, PageHeader } from "Components/ui";
import { Download, RefreshCw } from "Components/ui/icons";
import { AuditLogExplorer } from "./Components/AuditLogExplorer";
import { useAuditLogsData } from "./data";

const AuditLogsPage: React.FC = () => {
  const data = useAuditLogsData();

  return (
    <Page width="wide">
      <PageHeader
        title="Audit logs"
        description="Changes across tenants, users, roles, billing and settings: by admins, and by SAP itself when payments arrive. Entries are append-only and can't be edited."
        actions={
          <>
            <Button
              variant="secondary"
              leftIcon={<RefreshCw />}
              disabled={data.loading}
              onClick={data.reload}
            >
              Refresh
            </Button>
            <Button
              variant="secondary"
              leftIcon={<Download />}
              loading={data.exporting}
              onClick={() => void data.exportCsv()}
            >
              Export CSV
            </Button>
          </>
        }
      />
      <AuditLogExplorer data={data} />
    </Page>
  );
};

export default AuditLogsPage;
